// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__dzq78","loader-01":"style_loader-01__1N6qy"};